import {
  GET_CLIENT_KES,
  GET_CLIENT_MO,
  INSERT_CLIENT,
  GET_CLIENT_TYPE_KESM,
  GET_CLIENT_TYPE_MO,
  INSERT_CLIENT_TYPE,
  DELETE_CLIENT_MO,
  DELETE_CLIENT_KES,
  DELETE_CLIENT_TYPE,
  UPDATE_CLIENT_MO,
  UPDATE_CLIENT_KES,
  UPDATE_CLIENT_TYPE,
} from "../type";
const initialState = {
  GetClientsMo: [],
  GetClientsKesm: [],
  DeleteClientsKesm: [],
  DeleteClientsMo: [],
  UpdateClientsKesm: [],
  UpdateClientsMo: [],
  InsertClients: [],
  GetClientsTypeKesm: [],
  GetClientsTypeMo: [],

  InsertClientsType: [],
  DeleteClientsType: [],
  UpdateClientsType: [],


  loading: true,
};
const ClientR = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLIENT_MO:
      return {
        ...state,
        GetClientsMo: action.payload,
        loading: false,
      };
    case GET_CLIENT_KES:
      return {
        ...state,
        GetClientsKesm: action.payload,
        loading: false,
      };
    case INSERT_CLIENT:
      return {
        GetClients: state.GetClients,
        InsertClients: action.payload,
        loading: false,
      };
    case GET_CLIENT_TYPE_KESM:
      return {
        ...state,
        GetClientsTypeKesm: action.payload,
        loading: false,
      };
    case GET_CLIENT_TYPE_MO:
      return {
        ...state,
        GetClientsTypeMo: action.payload,
        loading: false,
      };
    case INSERT_CLIENT_TYPE:
      return {
        GetClientsType: state.GetClientsType,
        InsertClientsType: action.payload,
        loading: false,
      };
      case DELETE_CLIENT_TYPE:
        return {
          GetClientsType: state.GetClientsType,
          DeleteClientsType: action.payload,
          loading: false,
        };
        case UPDATE_CLIENT_TYPE:
          return {
            GetClientsType: state.GetClientsType,
            UpdateClientsType: action.payload,
            loading: false,
          };
    case DELETE_CLIENT_KES:
      return {
        GetClientsKesm: state.GetClientsKesm,
        DeleteClientsKesm: action.payload,
        loading: false,
      };
    case DELETE_CLIENT_MO:
      return {
        GetClientsMo: state.GetClientsMo,
        DeleteClientsMo: action.payload,
        loading: false,
      };
    // case DELETE_CLIENT_TYPE:
    //   return {
    //     GetClientsMo: state.GetClientsMo,
    //     DeleteClientsType: action.payload,
    //     loading: false,
    //   };
    case UPDATE_CLIENT_KES:
      return {
        GetClientsKesm: state.GetClientsKesm,
        UpdateClientsKesm: action.payload,
        loading: false,
      };
    case UPDATE_CLIENT_MO:
      return {
        GetClientsMo: state.GetClientsMo,
        UpdateClientsMo: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
export default ClientR;
